import { render } from "./BookingButton.vue?vue&type=template&id=01a45426"
import script from "./BookingButton.vue?vue&type=script&lang=js"
export * from "./BookingButton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pongsakornsomsri/workspace/neera-retreat-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__